import api from "./api";

export const getAppointments = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      page: params.page || 1,
      page_size: params.page_size || 20,
      // order_by: params.order_by || ["created_at"],
      order_direction: params.order_direction || ["DESC"],
      filters: params.filters || {},
      search: params.search || null,
    };

    const response = await api.post("/v1/tenant/appointment/list", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching appointments:", error);
    throw error;
  }
};

export const getAppointmentAdvisors = async (partyUuid, search = null) => {
  try {
    const body = {
      party_uuid: partyUuid,
      page: 1,
      page_size: 50,
      order_by: ["advisorName"],
      order_direction: ["ASC"],
    };

    if (search) {
      body.search = search;
    }

    const response = await api.post("/v1/tenant/appointment/advisor/list_filter", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching appointment advisors:", error);
    throw error;
  }
};

export const getAppointmentVehicles = async (partyUuid, search = null) => {
  try {
    const body = {
      party_uuid: partyUuid,
    };

    if (search) {
      body.search = search;
    }

    const response = await api.post(
      "/v1/tenant/appointment/vehicle/list_filter",
      body
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching appointment vehicles:", error);
    throw error;
  }
};

